import { render, staticRenderFns } from "./RevisionDocumentosOriginales.vue?vue&type=template&id=83f285a2"
import script from "./RevisionDocumentosOriginales.vue?vue&type=script&lang=js"
export * from "./RevisionDocumentosOriginales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f285a2')) {
      api.createRecord('83f285a2', component.options)
    } else {
      api.reload('83f285a2', component.options)
    }
    module.hot.accept("./RevisionDocumentosOriginales.vue?vue&type=template&id=83f285a2", function () {
      api.rerender('83f285a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/staff/RevisionDocumentosOriginales.vue"
export default component.exports